import React from "react";

export default function MetricCard({ metric, onClick }) {
  return (
    <button className="metric-card" onClick={() => onClick(metric)}>
      <div className={`metric-icon ${metric.colorClass}`}>
        <i className={`bi ${metric.icon}`}></i>
      </div>

      <div className="metric-content">
        <div className="metric-value-row">
          <span className="metric-value">{metric.value}</span>
          {metric.change && (
            <span className={`metric-change ${metric.changeType}`}>
              <i className={`bi ${metric.changeType === "up" ? "bi-arrow-up" : "bi-arrow-down"}`}></i>
              {metric.change}
            </span>
          )}
        </div>
        <div className="metric-label">{metric.label}</div>
        <div className="metric-helper">{metric.helper}</div>
      </div>

      <i className="bi bi-chevron-right metric-arrow"></i>
    </button>
  );
}